import { CLIENT_ROUTES } from '@client/constants';
export const getOrderPath = (shortId, accessKey, isAuthenticated) => isAuthenticated
    ? `/${CLIENT_ROUTES.orders}/${shortId}`
    : `/${CLIENT_ROUTES.order}/${shortId}?key=${accessKey}`;
